<template>
  <div class="marker-action">
    <list-action-form
      ref="form"
      :ids="ids"
      :labels="labels"
      :route="route"
      :method="method"
      @submitted="toggle"
    >
      <input type="hidden" name="contentBlockId" :value="contentBlockId" />
      <portal :to="name">
        <div :key="name" class="marker-action-contract-creator">
          <select-field
            name="contentBlocks"
            :items="contentBlocks"
            :empty-option="false"
            id-property="id"
            value-property="title"
            @selected="(name, id) => (contentBlockId = id)"
          />
          <a
            :class="[
              'btn',
              'btn-lg',
              'btn-secondary',
              { disabled: !contentBlockId }
            ]"
            @click.prevent="submit"
          >
            {{ labels.button }}
          </a>
        </div>
      </portal>
    </list-action-form>
  </div>
</template>

<script>
import ListAction from './ListAction.vue';
import { SelectField } from 'vue-bootstrap';

export default {
  components: {
    SelectField
  },
  extends: ListAction,
  props: {
    name: {
      type: String,
      required: true
    },
    contentBlocks: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      contentBlockId: null
    };
  },
  methods: {
    toggle() {
      this.$emit('reveal', this.name);
    }
  }
};
</script>
